<template>
    <div>
        
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    }
    
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Auth/Settings.vue